module.exports = __webpack_public_path__ + "img/banner.d8d97e3d.png";